import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HostListener } from '@angular/core';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-generic-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.scss']
})
export class GenericErrorComponent implements OnInit {
  title = 'WE\'RE SORRY';
  currentYear: number = new Date().getFullYear();

  public ownerUrl = environment.vistana_baseurl;
  public contactUsUrl = environment.contactUs;

  isMobileMenuOpen = false;

  // Desktop dropdown
  isUserMenuOpen = false;

  // Mobile user dropdown
  isMobileUserMenuOpen = false;

  constructor(private titleService: Title) {}

  @HostListener('document:click')
  closeAllMenus() {
    this.isUserMenuOpen = false;
    this.isMobileUserMenuOpen = false;
    this.isMobileMenuOpen = false;
  }

  ngOnInit() {
    this.titleService.setTitle('Error');
    (window as any).digitalData = { pageInfo: {}, userInfo: {} };
    (window as any).digitalData.pageInfo.siteSection = 'Authentication Portal';
    (window as any).digitalData.pageInfo.pageName = 'Authentication Portal | Error Page';
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    // optional: close other menus when hamburger opens
    if (this.isMobileMenuOpen) { this.isMobileUserMenuOpen = false; }
  }

  toggleUserMenu() {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  toggleMobileUserMenu(event: MouseEvent) {
    event.stopPropagation();
    this.isMobileUserMenuOpen = !this.isMobileUserMenuOpen;
    // optional: close hamburger when user menu opens
    if (this.isMobileUserMenuOpen) { this.isMobileMenuOpen = false; }
  }

  logout() {
    window.location.href = '/logout';
  }
}

